export class PointsCustomUtils {
    constructor(inPoints2d) {
        this.points = inPoints2d
        this.generateBounds()
    }
    generateBounds() {
        // Find minX, maxX, minY, maxY
        this.minX = 100000.0
        this.maxX = -100000.0
        this.minY = 100000.0
        this.maxY = -100000.0
        this.points.forEach(element => {
            if (element[0] > this.maxX) {
                this.maxX = element[0]
            }
            if (element[0] < this.minX) {
                this.minX = element[0]
            }
            if (element[1] > this.maxY) {
                this.maxY = element[1]
            }
            if (element[1] < this.minY) {
                this.minY = element[1]
            }
        });

        this.sizeX = this.maxX - this.minX
        this.sizeY = this.maxY - this.minY
    }

    getBounds() {
        return {
            minX: this.minX,
            maxX: this.maxX,
            minY: this.minY,
            maxY: this.maxY
        }
    }
}